import { render } from "./EmptyLayout.vue?vue&type=template&id=f528b000&scoped=true&lang=pug"
const script = {}

import "./EmptyLayout.vue?vue&type=style&index=0&id=f528b000&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f528b000"]])

export default __exports__